export const handleApiError = (error: unknown, message: string) => {
    console.error(message, error);
    if (error instanceof Error) {
      throw new Error(`${message}: ${error.message}`);
    } else {
      throw new Error(message);
    }
  };